import { Box, Button, Grid, Typography } from "@mui/material";
import { MbTextField } from "../../../../../components/MbTextFields";
import { useUser } from "../../../../../contexts/user.context";
import { useForm } from "react-hook-form";
import { mobilizeiStoresService } from "../../../../../services/mobilizei/stores.service";
import { useState } from "react";
import CompanyAccountDialog from "../CompanyAccountDialog";
import _ from "lodash";
import useAppInfo from "../../../../../hooks/appInfo.hook";
import { storeStatus } from '../../../../../utils/constants';

export default function AccountContent({ blocked }) {
  const { user, setUser } = useUser();
  const { appInfo } = useAppInfo();

  const isDisabled = (appInfo?.storeStatus !== storeStatus.ACTIVE) || blocked;

  const [showCompanyAccountDialog, setShowCompanyAccountDialog] = useState(false);

  const { getValues, handleSubmit, register, formState: { errors } } = useForm({
    defaultValues: {
      developerAccountEmail: user?.store?.platforms?.android?.developerAccountEmail,
      developerAccountName: user?.store?.platforms?.android?.developerAccountName
    }
  });

  function onSubmit() {
    setShowCompanyAccountDialog(true)
  }

  function goToNextStep() {
    let data = getValues();

    if (data.developerAccountEmail) {
      data.developerAccountEmail = data.developerAccountEmail.trim()
    }

    mobilizeiStoresService
      .updateStoreById(user?.store?.platformId, user?.store?.id, {
        platforms: {
          android: {
            developerAccountEmail: data.developerAccountEmail,
            developerAccountName: data.developerAccountName
          }
        }
      }).catch(() => null)

    // Set the local user properties
    setUser({
      ...user,
      store: {
        ...user?.store,
        platforms: {
          ...user?.store?.platforms,
          android: {
            ...user?.store?.platforms?.android,
            developerAccountEmail: data.developerAccountEmail,
            developerAccountName: data.developerAccountName
          }
        }
      }
    })

    setShowCompanyAccountDialog(false)
  }

  return (
    <Box>
      {user?.store?.platforms?.android?.developerAccountName
        && user?.store?.platforms?.android?.developerAccountEmail
        ? (
          <Grid
            container
            display={'flex'}
            flexDirection={'column'}
            spacing={2}
          >
            <Grid item>
              <Typography variant="body1">
                Nome da conta de desenvolvedor Google: <strong style={{ color: '#3cd568' }}>
                  {user?.store?.platforms?.android?.developerAccountName}
                </strong>
              </Typography>
            </Grid>

            <Grid item>
              <Typography variant="body1">
                E-mail da conta de desenvolvedor Google: <strong style={{ color: '#3cd568' }}>
                  {user?.store?.platforms?.android?.developerAccountEmail}
                </strong>
              </Typography>
            </Grid>

          </Grid>

        )
        : (
          <Grid
            container
            component="form"
            display={'flex'}
            flexDirection={'column'}
            spacing={2}
            onSubmit={handleSubmit(onSubmit)}
          >

            <Grid item xs={12}>
              <Typography variant="body1" mb={2}>
                Para publicar a versão Android do seu aplicativo, <strong>é necessário criar uma conta de desenvolvedor Google do tipo organizacional</strong>.
              </Typography>

              <Typography variant="body1" mb={2}>
                Essa conta tem um custo único de <strong>U$ 25 (vinte e cinco dólares)</strong>, pagos diretamente ao Google.
              </Typography>

              <Typography variant="body1" mb={2}>
                Para facilitar esse processo, preparamos um tutorial completo:
                <a
                  href="https://mobilizei.com.br/tutoriais/como-criar-conta-desenvolvedor-google-play"
                  target="_blank"> clique aqui para acessar</a>.
              </Typography>

              <Typography variant="body1" mb={2}>
                <strong>
                  Após criar sua conta, o Google irá solicitar a realização de algumas verificações obrigatórias:
                </strong>
              </Typography>

              <Typography variant="body1" mb={2} ml={2}>
                <strong>•</strong> Confirmação de identidade;
              </Typography>

              <Typography variant="body1" mb={2} ml={2}>
                <strong>•</strong> Verificação do site;
              </Typography>

              <Typography variant="body1" mb={2} ml={2}>
                <strong>•</strong> Verificação do telefone.
              </Typography>

              <Typography variant="subtitle1" mb={2}>
                Certifique-se de concluir todas essas etapas <strong>antes de seguir para o próximo passo!</strong>
              </Typography>

              <Typography variant="subtitle1" mb={2}>
                Com o processo finalizado, preencha abaixo o nome e o e-mail da sua conta de desenvolvedor Google:
              </Typography>
            </Grid>

            <Grid item>
              <MbTextField
                error={errors.developerAccountName?.message}
                label="Nome da sua conta de desenvolvedor Google:"
                inputProps={{
                  placeholder: "Digite o nome da sua conta de desenvolvedor Google Organizacional",
                  disabled: isDisabled
                }}
                register={register('developerAccountName', {
                  required: "Insira o nome da sua conta de desenvolvedor Google Organizacional para continuar."
                })}
              />

              <MbTextField
                error={errors.developerAccountEmail?.message}
                label="E-mail da sua conta de desenvolvedor Google:"
                inputProps={{
                  placeholder: "Digite o e-mail da sua conta de desenvolvedor Google Organizacional",
                  disabled: isDisabled
                }}
                register={register('developerAccountEmail', {
                  required: "Insira o e-mail da sua conta de desenvolvedor Google Organizacional para continuar."
                })}
              />

              <Box display='flex' justifyContent='center' marginTop={4} width='100%'>
                <Button variant="contained" disabled={isDisabled} type="submit">
                  próximo passo
                </Button>
              </Box>

              {blocked &&
                <Box display='flex' justifyContent='center' marginTop={2} width='100%'>
                  <Typography variant="body1" fontWeight='bold' marginTop={1}>
                    Finalize a criação do seu número DUNS para continuar
                  </Typography>
                </Box>
              }
            </Grid>
          </Grid>
        )}

      <CompanyAccountDialog
        open={showCompanyAccountDialog}
        handleClose={() => setShowCompanyAccountDialog(false)}
        goToNextStep={goToNextStep}
      />
    </Box>
  )
}